<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.75" y="0.75" width="22.5" height="22.5" rx="11.25" stroke="white" stroke-width="1.5"/>
<path d="M5 13L9.66667 17.5L19 8" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
